import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/axios';
import { GET_TRANSIT_KEY } from '@/services/apis/queries/transits/use-get-transit';
import { GET_TRANSITS_KEY } from '@/services/apis/queries/transits/use-get-transits';
import type { DdsError, DdsStatus } from '@/types/core/transit/transit';

export type SendTransitDdsError = {
  ddsError?: DdsError | null;
  ddsSubmissionUncertain?: boolean;
  ddsRejectionCodes?: string[];
  issues?: { code: string; sku?: string }[];
};

export function useSendTransitDds(
  transitId: string,
  purchaseOrderId: number,
  callbacks: {
    onSuccess: () => void;
    onError: (error: Error) => void;
  },
  operation: 'send' | 'amend' = 'send',
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await api.post<{ ddsStatus: DdsStatus }>(
        `/transits/${transitId}/purchase-orders/${purchaseOrderId}/dds/${operation}`,
      );
      return response.data;
    },
    retry: false,
    onSuccess: callbacks.onSuccess,
    onError: callbacks.onError,
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...GET_TRANSIT_KEY, transitId],
        }),
        queryClient.invalidateQueries({ queryKey: GET_TRANSITS_KEY }),
      ]);
    },
  });
}
